import keys from '../config/keys.js';
const { mainWebsiteUrl, referralBaseLink } = keys;

export const PROFILE_LINK = '/setting/profile';
export const COURSES_EXTERNAL_LINK = `${mainWebsiteUrl}/courses`;
export const REFERRAL_BASE_LINK = `${referralBaseLink}/`;
export const TRAINER_FEEDBACK_URL_SLUG = 'trainer-feedback';
export const PAID_COURSES_DISCOVERY_PAGE =
  'https://nasacademy.com/courses?mode=courses';
